<template>
  <div>
    <!-- <h1 class="headline-1 mx-12" v-if="creatingNewVariation">
      Create as new variation
    </h1> -->
    <v-layout align-center justify-center>
      <v-card max-width="600">
        <v-card-title class="headline grey lighten-2" primary-title>
          Old location of {{ SKU }}
        </v-card-title>
        <br />
        <v-card-text>
          <v-row v-if="locationsEmpty">
            <v-alert prominent type="error">
              <v-row align="center" class="mx-4">
                <v-col>
                  Couldn't find any product locations. Please check location in
                  linnworks manualy for product {{ SKU }}.
                </v-col>
              </v-row>
            </v-alert>
          </v-row>
          <div class="px-8">
            <v-row>
              <v-col>
                <h2>Scan the old location in the field below</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  label="Old location"
                  v-model="oldLocationValue"
                  :items="locations"
                  type="text"
                  filled
                  @change="onInputChange"
                  :loading="loadingItems"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="locationsEmpty" color="#66BB6A" @click="reset">
            Continue with new product
          </v-btn>
          <v-btn
            v-else
            color="#66BB6A"
            @click="continueOldLocation"
            :disabled="oldLocationValue === ''"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: "OldLocationCard",
  props: {
    creatingNewVariation: Boolean,
    SKU: String,
  },
  data: () => ({
    oldLocationValue: "",
    locations: [],
    loadingItems: true,
    locationsEmpty: false,
  }),
  methods: {
    continueOldLocation() {
      this.$emit("continueOldLocation");
    },
    onInputChange(val) {
      this.$emit("onInputChange", val);
    },
    getProductLocations() {
      let finalSKU = "";
      if (this.SKU.includes("/")) {
        finalSKU = this.SKU.replace(/\//g, "_");
      } else {
        finalSKU = this.SKU;
      }
      this.$store
        .dispatch("getProductLocations", finalSKU)
        .then((response) => {
          this.loadingItems = false;
          if (response.data.length == 0) {
            this.locationsEmpty = true;
          } else {
            this.locations = response.data;
          }
        })
        .catch((error) => {
          console.log("Ups", error);
        });
    },
    reset() {
      this.$router.go();
    },
  },
  mounted() {
    this.getProductLocations();
  },
};
</script>